module.exports = __webpack_public_path__ + "316d8760aca9ac516f923cccc7c4732b.pdf";